export const isRecaptchaEnabled = () =>
  process.env.REACT_APP_ENABLE_RECAPTCHA === "true";

const loadRecaptchaScript = (siteKey) => {
  return new Promise((resolve, reject) => {
    if (window.grecaptcha?.ready) {
      window.grecaptcha.ready(() => resolve(window.grecaptcha));
      return;
    }

    const existingScript = document.querySelector(
      `script[src*="recaptcha/api.js"]`
    );
    if (existingScript) {
      existingScript.addEventListener("load", () => {
        window.grecaptcha.ready(() => resolve(window.grecaptcha));
      });
      existingScript.addEventListener("error", reject);
      return;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.onload = () => {
      window.grecaptcha.ready(() => resolve(window.grecaptcha));
    };
    script.onerror = () => reject(new Error("Failed to load reCAPTCHA script"));
    document.head.appendChild(script);
  });
};

export const getRecaptchaToken = async (action = "otp_generate") => {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  if (!siteKey) {
    throw new Error("REACT_APP_RECAPTCHA_SITE_KEY is not configured");
  }

  const grecaptcha = await loadRecaptchaScript(siteKey);
  return grecaptcha.execute(siteKey, { action });
};
